"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _DatePicker = require("./DatePicker.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 日期組件
 */
var RangePicker = _antd.DatePicker.RangePicker;

var DatePicker = function DatePicker(_ref) {
  var defaultValue = _ref.defaultValue,
      variant = _ref.variant,
      onChange = _ref.onChange;

  var onDateChange = function onDateChange(date, dateString) {
    onChange && onChange(date, dateString);
  };

  return /*#__PURE__*/_react.default.createElement(_DatePicker.UiDatePicker, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(RangePicker, {
    defaultValue: defaultValue,
    onChange: function onChange(date, dateString) {
      onDateChange(date, dateString);
    }
  }));
};

var _default = DatePicker;
exports.default = _default;
DatePicker.propTypes = {
  defaultValue: _propTypes.default.array,
  variant: _propTypes.default.string,
  onChange: _propTypes.default.func
};